import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { AppUtilityService } from 'src/app/app-utility.service';
import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

import { ZARcurrencyPipe } from '@lmsSharedUI';

import { LmsModalFrameComponent } from '../../ui/lms-modal-frame/lms-modal-frame.component';

async function loadXLSX() {
  const XLSX = await import('xlsx');
  return XLSX;
}

@Component({
  selector: 'app-branch-performance-report',
  templateUrl: './branch-performance-report.component.html',
  styleUrls: ['./branch-performance-report.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ZARcurrencyPipe, NgxPaginationModule, LmsModalFrameComponent],
})
export class BranchPerformanceReportComponent implements OnInit {
  @Input() totalBranchCapital!: string; // The @Input() decorator makes this property bindable
  @Input() totalBranchCount!: string;
  @Input() startDate!: string;
  @Input() endDate!: string;

  // @ViewChild(BasicEmployersSearchComponent) employerBasicSearchComponent: BasicEmployersSearchComponent;

  performanceList: any[] = [];
  title = 'export-excel';
  fileName = '';

  //totalBranchCount: any;
  //totalBranchCapital: any;

  @ViewChild('TABLE') table: ElementRef;
  //displayedColumns = ['position', 'name', 'weight', 'symbol'];
  dataSource = this.performanceList;
  config: PaginationInstance = {
    id: 'pager',
    itemsPerPage: 15,
    currentPage: 1,
  };

  constructor(
    // private route: ActivatedRoute,
    // private clientSearch: ClientDetailsService,
    // public quoteStoreService: QuoteStoreService,
    public global_utility: AppUtilityService,
    public dialogRef: MdbModalRef<BranchPerformanceReportComponent>
  ) {}
  ngOnInit(): void {

   const cap = this.totalBranchCapital;
   const cnt = this.totalBranchCount;
  const stART = this.startDate;
  const end = this.endDate;
  }

  exportLoansToExcel(): void {
    this.title = 'export-excel';
    this.fileName = `Branch Report_${new Date()}.xlsx`;

    /* pass here the table id */
    //const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.lstQuotes);
    // table_to_sheet(this.lstQuotes);
    this.global_utility.startLoading('Exporting data to Excel.');
    loadXLSX()
      .then((XLSX) => {
        const ws = XLSX.utils.table_to_sheet(this.table.nativeElement);

        /* generate workbook and add the worksheet */

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */

        XLSX.writeFile(wb, this.fileName);
        XLSX.writeFile(wb, this.fileName);
        this.global_utility.stopLoading();
      })
      .catch((err) => {
        this.global_utility.stopLoading();
        this.global_utility.error('Failed to import Excel:', err);
      });
  }

  close() {
    this.dialogRef.close();
    //return this.dialogRef.close(this.employmentDetailsForm.value);
  }
}
